import { FC } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { FaApple, FaAndroid, FaLink } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useModal } from 'store/modal';
import styled from 'styled-components';

const InstructionsBG: FC = () => {
  const { showModal } = useModal();

  const handleAlternativeMethodClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    showModal({
      type: 'info',
      heading: 'Алтернативен метод',
      size: 'lg',
      content: (
        <div className="d-flex flex-column text-left px-3">
          <h5>Ако имате проблем да сканирате QR код-а с камерата Ви, може да го въведете ръчно.</h5>
          <ol>
            <li>Натиснете бутона +(плюс).</li>
            <li>
              Изберете <b>“Other Account“ / “Друг акаунт“</b>
            </li>
            <li>Изберете опцията налична най-долу “Or enter code manually“</li>
            <li>
              В полето <b>“Account name“ / “Име на акаунт“</b> въведете - eHR и вашия имейл
            </li>
            <li>
              В полето <b>“Secret key“ / “Таен ключ“</b>, въведете стойността за Key от страницата по-долу, например{' '}
              <b>“ABC12345612345FF“</b>
            </li>
            <li>
              Натиснете <b>“Finish“ / “Готово“</b>
            </li>
            <li>
              В eHR натиснете зеления бутон <b>“Активирай“</b>
            </li>
          </ol>
        </div>
      ),
    });
  };

  return (
    <>
      <p>
        За да използвате системата, е необходимо да активирате функцията “Двуфакторно автентикиране“. За да направите
        това, следвайте стъпките по-долу:
      </p>
      <Tabs defaultActiveKey="android">
        <Tab
          eventKey="android"
          title={
            <>
              <FaAndroid
                size={20}
                style={{ marginRight: '0.25rem' }}
              />{' '}
              Android
            </>
          }
        >
          <div className="pt-3 pb-3">
            <StyledOl>
              <StyledLi>
                Потърсете приложението <b>“Microsoft Authenticator“</b> на своя телефон или таблет и отворете го и
                преминете към стъпка <b>4 по-долу</b>.
              </StyledLi>
              <StyledLi>
                Ако го нямате инсталирано, може да го свалите и инсталирате от{' '}
                <Link
                  to={{
                    pathname: 'https://play.google.com/store/apps/details?id=com.azure.authenticator',
                  }}
                  target="_blank"
                >
                  <FaLink size={12} /> ТУК
                </Link>{' '}
                или от <b>Play Store</b>
              </StyledLi>
              <StyledLi>
                Ако сте го инсталирали току-що след стартиране:
                <NestedOl>
                  <NestedLi>
                    Натиснете <b>“Accept“ / “Приеми“</b>, след което <b>“Continue“ / “Продължаване“</b>.
                  </NestedLi>
                  <NestedLi>
                    След това изберете опцията налична най-долу - <b>“Scan a QR code“ / “Сканиране QR код“</b>.
                  </NestedLi>
                  <NestedLi>Възможно е, приложението да ви пита за достъп до камерата Ви, моля позволете го.</NestedLi>
                  <NestedLi>
                    Насочете телефона към <b>QR кодa</b> по-долу.
                  </NestedLi>
                  <NestedLi>
                    Преминете към <b>стъпка 5</b>.
                  </NestedLi>
                </NestedOl>
              </StyledLi>
              <StyledLi>
                Ако вече разполагате с приложението, в горния десен ъгъл, натиснете бутона +(плюс).
                <NestedOl>
                  <NestedLi>
                    Изберете последната опция <b>“Other Account“ / “Друг акаунт“</b>
                  </NestedLi>
                  <NestedLi>Възможно е, приложението да ви пита за достъп до камерата Ви, моля позволете го.</NestedLi>
                  <NestedLi>Насочете телефона към QR кодa по-долу.</NestedLi>
                  <NestedLi>
                    Ако срещатe затруднения с използването на камерата може да използвате{' '}
                    <div
                      style={{
                        color: '#716aca',
                        cursor: 'pointer',
                        textDecoration: 'none',
                      }}
                      onMouseOver={e => {
                        e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onMouseOut={e => {
                        e.currentTarget.style.textDecoration = 'none';
                      }}
                      onFocus={e => {
                        e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onBlur={e => {
                        e.currentTarget.style.textDecoration = 'none';
                      }}
                      onClick={handleAlternativeMethodClick}
                    >
                      <FaLink size={12} /> Алтернативен метод
                    </div>
                  </NestedLi>
                </NestedOl>
              </StyledLi>
              <StyledLi>
                Кодът от приложението ще излезе на вашия екран и е необходимо да го въведете в полето <b>“Код“</b> в
                eHR. Кодът се сменя на всеки 30 секунди.
              </StyledLi>
              <StyledLi>
                Натиснете зеления бутон <b>“Активирай“</b>.
              </StyledLi>
              <StyledLi>
                <b>Ако кодът е правилен, ще активирате двуфакторната автентикация - честито!</b>
              </StyledLi>
              <StyledLi>
                Ако не успеете, изчакайте да се генерира нов код и опитайте отново. Алтернативно може да обновите
                страницата и направите опит да го сканирате отново.
              </StyledLi>
              <StyledLi>
                За да работи коректно двуфакторната автентикация е нужно датата и часът на телефона ви да са точни, моля
                провете това в меню Настройки.
              </StyledLi>
            </StyledOl>
          </div>
        </Tab>
        <Tab
          eventKey="ios"
          title={
            <>
              <FaApple
                size={20}
                style={{ marginRight: '0.25rem' }}
              />{' '}
              iOS
            </>
          }
        >
          <div className="pt-3 pb-3">
            <StyledOl>
              <StyledLi>
                Потърсете приложението <b>“Microsoft Authenticator“</b> на своя телефон или таблет, отговорете го и
                преминете към стъпка <b>4 по-долу</b>.
              </StyledLi>
              <StyledLi>
                Ако го нямате инсталирано, може да го свалите и инсталирате от{' '}
                <Link
                  to={{
                    pathname: 'https://apps.apple.com/us/app/microsoft-authenticator/id983156458',
                  }}
                  target="_blank"
                >
                  <FaLink size={12} /> ТУК
                </Link>{' '}
                или от <b>App Store</b>
              </StyledLi>
              <StyledLi>
                Ако сте го инсталирали току-що след стартиране:
                <NestedOl>
                  <NestedLi>
                    Натиснете <b>“Accept“ / “Приеми“</b>, след което <b>“Continue“ / “Продължаване“</b>.
                  </NestedLi>
                  <NestedLi>
                    След това изберете опцията налична най-долу - <b>“Scan a QR code“ / “Сканиране QR код“</b>.
                  </NestedLi>
                  <NestedLi>Възможно е, приложението да ви пита за достъп до камерата Ви, моля позволете го.</NestedLi>
                  <NestedLi>
                    Насочете телефона към <b>QR кодa</b> по-долу.
                  </NestedLi>
                  <NestedLi>
                    Преминете към <b>стъпка 5</b>.
                  </NestedLi>
                </NestedOl>
              </StyledLi>
              <StyledLi>
                Ако вече разполагате с приложението, в горния десен ъгъл, натиснете бутона +(плюс).
                <NestedOl>
                  <NestedLi>
                    Изберете последната опция <b>“Other Account“ / “Друг акаунт“</b>
                  </NestedLi>
                  <NestedLi>Възможно е, приложението да ви пита за достъп до камерата Ви, моля позволете го.</NestedLi>
                  <NestedLi>Насочете телефона към QR кодa по-долу.</NestedLi>
                  <NestedLi>
                    Ако срещатe затруднения с използването на камерата може да използвате{' '}
                    <div
                      style={{
                        color: '#716aca',
                        cursor: 'pointer',
                        textDecoration: 'none',
                      }}
                      onMouseOver={e => {
                        e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onMouseOut={e => {
                        e.currentTarget.style.textDecoration = 'none';
                      }}
                      onFocus={e => {
                        e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onBlur={e => {
                        e.currentTarget.style.textDecoration = 'none';
                      }}
                      onClick={handleAlternativeMethodClick}
                    >
                      <FaLink size={12} /> Алтернативен метод
                    </div>
                  </NestedLi>
                </NestedOl>
              </StyledLi>
              <StyledLi>
                Кодът от приложението ще излезе на вашия екран и е необходимо да го въведете в полето <b>“Код“</b> в
                eHR. Кодът се сменя на всеки 30 секунди.
              </StyledLi>
              <StyledLi>
                Натиснете зеления бутон <b>“Активирай“</b>.
              </StyledLi>
              <StyledLi>
                <b>Ако кодът е правилен, ще активирате двуфакторната автентикация - честито!</b>
              </StyledLi>
              <StyledLi>
                Ако не успеете, изчакайте да се генерира нов код и опитайте отново. Алтернативно може да обновите
                страницата и направите опит да го сканирате отново.
              </StyledLi>
              <StyledLi>
                За да работи коректно двуфакторната автентикация е нужно датата и часът на телефона ви да са точни, моля
                провете това в меню Настройки.
              </StyledLi>
            </StyledOl>
          </div>
        </Tab>
      </Tabs>
    </>
  );
};

export default InstructionsBG;

// Styled wrapper for the main ordered list
const StyledOl = styled.ol`
  counter-reset: section;
  list-style-type: none;
  padding-left: 20px;
`;

// Styled component for top-level list items
const StyledLi = styled.li`
  counter-increment: section;
  &:before {
    content: counters(section, '.') '. ';
    margin-right: 5px;
  }
`;

// Styled wrapper for nested ordered lists
const NestedOl = styled.ol`
  counter-reset: subsection;
  list-style-type: none;
  padding-left: 40px; // Indent nested list items
`;

// Styled component for nested list items
const NestedLi = styled.li`
  counter-increment: subsection;
  &:before {
    content: counter(section) '.' counter(subsection) ' ';
    margin-right: 5px;
  }
`;
